import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material'

import dayjs from 'dayjs'
import ONBOARDING_MODALS from './demoModalsConfig'

import s from './styles.module.scss'

const ModalManager = ({ centreCreationDate }) => {
  const [modalToShow, setModalToShow] = useState(null)

  const getCurrentModal = () => {
    const today = dayjs()
    const creation = dayjs(centreCreationDate)
    const dayDiff = today.diff(creation, 'day')
    const modal = ONBOARDING_MODALS[dayDiff]

    if (!modal) return null
    if (dayDiff === 0 && localStorage.getItem('TOUR_KEY') !== '1') return null

    const storageKey = `shownModal_${modal.key}_${today.format('YYYY-MM-DD')}`
    const alreadyShown = localStorage.getItem(storageKey)

    if (!alreadyShown) {
      return modal
    }

    return null
  }

  useEffect(() => {
    if (!centreCreationDate) return
    const modal = getCurrentModal()
    setModalToShow(modal)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [centreCreationDate])

  useEffect(() => {
    const handleTourFinish = () => {
      const modal = getCurrentModal()
      setModalToShow(modal)
    }

    window.addEventListener('tourFinished', handleTourFinish)
    return () => window.removeEventListener('tourFinished', handleTourFinish)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleClose = () => {
    if (modalToShow?.onConfirm) {
      modalToShow.onConfirm()
    }
    const today = dayjs().format('YYYY-MM-DD')
    const storageKey = `shownModal_${modalToShow.key}_${today}`
    localStorage.setItem(storageKey, 'true')
    setModalToShow(null)
  }

  if (!modalToShow) return null

  return (
    <Dialog
      disableEscapeKeyDown={true}
      open={!!modalToShow}
      setOpen={() => setModalToShow(null)}
      onClose={handleClose}
      maxWidth="sm"
      classes={{ paper: s.paperProps }}
    >
      <DialogTitle className={s.dialogTitle}>
        <div className={s.titleCentered}>{modalToShow.title}</div>
        <Button onClick={handleClose} className={s.closeBtn}>
          X
        </Button>
      </DialogTitle>

      <DialogContent className={s.mainContainer}>
        {typeof modalToShow.content === 'function' ? modalToShow.content(handleClose) : modalToShow.content}
      </DialogContent>
    </Dialog>
  )
}

export default ModalManager
